import {
  Button,
  Dialog,
  DialogBody,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@theprelude/ds";

export const DeleteExceptionDialog = ({
  open,
  onConfirm,
  onOpenChange,
}: {
  open: boolean;
  onConfirm: () => void;
  onOpenChange: (open: boolean) => void;
}) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent
      disableImplicitClose
      hideClose
      onEscapeKeyDown={() => onOpenChange(false)}
    >
      <DialogHeader>
        <DialogTitle>
          Are you sure you want to delete this exception?
        </DialogTitle>
      </DialogHeader>
      <DialogBody>
        This will affect the issue counts that previously had this exception
        applied to them.
      </DialogBody>
      <DialogFooter>
        <DialogClose asChild>
          <Button intent="secondary">Cancel</Button>
        </DialogClose>
        <Button intent="negative" onClick={onConfirm}>
          Delete
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
